import { Icon } from '@iconify/react';

const statusClasses = {
    pending: 'tw-inline-flex tw-items-center tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-leading-4 tw-capitalize tw-bg-amber-50 tw-border-amber-600 tw-text-amber-600',
    approved: 'tw-inline-flex tw-items-center tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-leading-4 tw-capitalize tw-bg-emerald-50 tw-border-emerald-600 tw-text-emerald-600',
    waiting_for_approval: 'tw-inline-flex tw-items-center tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-leading-4 tw-capitalize tw-bg-sky-50 tw-border-sky-600 tw-text-sky-600',
    rejected: 'tw-inline-flex tw-items-center tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-leading-4 tw-capitalize tw-bg-rose-50 tw-border-rose-600 tw-text-rose-600',
};

const formatCoursePrice = (course) => {
    if (course.course_type !== 'paid') return 'Free';
    if (course.course_price === null || course.course_price === undefined || course.course_price === '') return '—';
    const price = Number(course.course_price);
    if (!Number.isFinite(price)) return String(course.course_price);
    const fractionDigits = Number.isInteger(price) ? 0 : 2;
    return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(price);
};

const getVisibilityConfig = (course) => {
    if (course.access_scope === 'classroom_only') {
        return {
            label: 'Classroom Only',
            title: 'Only members of the selected classrooms can access this course.',
            icon: 'fluent:building-people-20-regular',
            className: 'tw-border-indigo-600 tw-bg-indigo-50 tw-text-indigo-700',
        };
    }

    if (Number(course.is_public) === 1) {
        return {
            label: 'Public',
            title: 'Available to all organizations on the platform.',
            icon: 'fluent:globe-20-regular',
            className: 'tw-border-sky-600 tw-bg-sky-50 tw-text-sky-700',
        };
    }

    return {
        label: 'Private',
        title: 'Available only to authorized users in this organization.',
        icon: 'fluent:lock-closed-20-regular',
        className: 'tw-border-slate-500 tw-bg-slate-50 tw-text-slate-700',
    };
};

function CourseTableInfoCells({ course, statusClassName }) {
    const category = Array.isArray(course.course_category)
        ? course.course_category.filter(Boolean).join(', ') || 'Uncategorized'
        : course.course_category || 'Uncategorized';
    const resolvedStatusClassName = statusClassName || statusClasses[course.course_status] || statusClasses.pending;
    const visibility = getVisibilityConfig(course);

    return (
        <>
            <td className="tw-py-4 tw-align-middle tw-text-left">{formatCoursePrice(course)}</td>
            <td className="tw-py-4 tw-align-middle tw-text-left">
                <span className="tw-line-clamp-2 tw-break-words" title={category}>
                    {category}
                </span>
            </td>
            <td className="tw-py-4 tw-align-middle tw-text-left">
                <span className={resolvedStatusClassName}>
                    {course.course_status?.replaceAll('_', ' ')}
                </span>
            </td>
            <td className="tw-py-4 tw-align-middle tw-text-left">
                <span
                    className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-leading-4 ${visibility.className}`}
                    title={visibility.title}
                >
                    <Icon icon={visibility.icon} width="14" height="14" aria-hidden="true" />
                    {visibility.label}
                </span>
            </td>
        </>
    );
}

export default CourseTableInfoCells;
